import Storage from '../../services/Storage';
import { Permissions } from '../../constants/Permissions';
import { Roles } from '../../constants/Roles';
import './Navitem.css';
import { store } from '../..';

class MainNavComponent {
  static getMenus = () => {
    const MainNav = [];
    // const permissions = Storage.getUserPermissionDetail();
    const permissions = store.getState().UserGetReducer.permissionArr;
    let userInfo = Storage.getUserInfoDetail();
    let userId = userInfo ? userInfo.id : null;
    let roleName = userInfo ? userInfo.role : '';
    if (permissions && permissions !== undefined) {
      for (let i = 0; i < permissions.length; i++) {
        const permission = permissions[i];
        // CNF User
        if (permission === Permissions.CNF_DASHBOARD) {
          let value = {
            icon: 'dashboardMenuIcon menuImg',
            label: 'CNF Dashboard',
            content: [
              {
                label: 'CNF Dashboard',
                to: '#/cnf/cnf-dashboard',
              },
            ],
          };
          MainNav[0] = value;
        }
        if (permission === Permissions.CNF_OPEN_ORDER) {
          let value = {
            icon: 'openOrderMenuIcon menuImg',
            label: 'Open Order',
            content: [
              {
                label: 'Open Order',
                to: '#/cnf/open-orders',
              },
            ],
          };
          MainNav[1] = value;
        }
        if (permission === Permissions.CNF_FULFILLED_ORDER) {
          let value = {
            icon: 'fulfilledOrderMenuIcon menuImg',
            label: 'Fulfilled Order',
            content: [
              {
                label: 'Fulfilled Order',
                to: '#/cnf/fulfilled-orders',
              },
            ],
          };
          MainNav[2] = value;
        }

        if (permission === Permissions.DASHBOARD) {
          let value = {
            icon: 'dashboardMenuIcon menuImg',
            label: 'Dashboard',
            content: [
              {
                label: 'Dashboard',
                to: '#/agrocel/dashboard',
              },
            ],
          };
          MainNav[0] = value;
        }

        // New Dealer
        if (permission === Permissions.NEW_DEALER_REGISTRATION) {
          let value = {
            icon: 'newDealerMenuIcon menuImg',
            label: 'New Dealer Reg.',
            content: [],
          };
          MainNav[1] = value;
        }
        if (permission === Permissions.PIPELINE) {
          MainNav[1].content[0] =
            roleName === Roles.TM_NAME
              ? {
                label: 'PipeLine',
                to: `#/pages/pipeline/${userId}`,
              }
              : {
                label: 'PipeLine',
                to: `#/pages/pipeline-summary`,
              };
        } else if (permission === Permissions.APPROVED_APP) {
          MainNav[1].content[1] =
            roleName === Roles.TM_NAME
              ? {
                label: 'Approved App.',
                to: `#/pages/approved-app/${userId}`,
              }
              : {
                label: 'Approved App.',
                to: `#/pages/approved-app-summary`,
              };
        } else if (permission === Permissions.REJECTED_APP) {
          MainNav[1].content[2] =
            roleName === Roles.TM_NAME
              ? {
                label: 'Rejected App.',
                to: `#/pages/rejected-app/${userId}`,
              }
              : {
                label: 'Rejected App.',
                to: `#/pages/rejected-app-summary`,
              };
        }

        // Dealer Meeting
        if (permission === Permissions.DEALER_MEETING) {
          let value = {
            icon: 'dealerMeetingMenuIcon menuImg',
            label: 'Dealer Meeting',
            content: [],
          };
          MainNav[2] = value;
        }
        if (permission === Permissions.OPEN_MEETING) {
          MainNav[2].content[0] =
            roleName === Roles.TM_NAME
              ? {
                label: 'Open Meeting',
                to: `#/meeting/open-meeting/mtd/${userId}`,
              }
              : {
                label: 'Open Meeting',
                to: `#/meeting/open-meeting-user-list`,
              };
        } else if (permission === Permissions.MEETING_HISTORY) {
          MainNav[2].content[1] =
            roleName === Roles.TM_NAME
              ? {
                label: 'Meeting History',
                to: `#/meeting/meeting-history/mtd/${userId}`,
              }
              : {
                label: 'Meeting History',
                to: `#/meeting/meeting-history-user-list`,
              };
        }

        // Order Summary
        if (permission === Permissions.ORDER_SUMMARY) {
          let value =
            roleName === Roles.TM_NAME
              ? {
                icon: 'orderSummaryMenuIcon menuImg',
                label: 'Order Summary',
                to: `#/order/order-summary/mtd/${userId}`,
              }
              : {
                icon: 'orderSummaryMenuIcon menuImg',
                label: 'Order Summary',
                to: `#/order/order-summary-user-list`,
              };
          MainNav[3] = value;
        }

        // Survey Form
        if (permission === Permissions.SURVEY_FORM) {
          // if (
          //   roleName === Roles.TM_NAME ||
          //   roleName === Roles.SH_NAME ||
          //   roleName === Roles.NH_NAME ||
          //   roleName === Roles.BH_NAME
          // ) {
            
          // }
          let isMobile = false;
            let value = {
              icon: 'surveyFormIcon menuImg',
              label: 'Survey & Forms',
              to: `#/survey/survey-form?isMobile=${isMobile}`,
            };
            MainNav[5] = value;
        }

        // Dealer Engagement
        if (permission === Permissions.DEALER_ENGAGEMENT) {
          let value = {
            icon: 'dealerEngMenuIcon menuImg',
            label: 'Dealer Engagement',
            content: [],
          };
          MainNav[6] = value;
        }
        if (permission === Permissions.DEALER_BIRTHDAY) {
          MainNav[6].content[0] =
            roleName === Roles.TM_NAME
              ? {
                label: 'Dealer Birthdays',
                to: `#/dealer/birth-day/${userId}`,
              }
              : {
                label: 'Dealer Birthdays',
                to: `#/dealer/birth-day-summary`,
              };
        } else if (permission === Permissions.DEALER_MARRIAGE_ANNIVERSARY) {
          MainNav[6].content[1] =
            roleName === Roles.TM_NAME
              ? {
                label: 'Dealer Merriage Anniversary',
                to: `#/dealer/m-anniversary/${userId}`,
              }
              : {
                label: 'Dealer  Merriage Anniversary',
                to: `#/dealer/m-anniversary-summary`,
              };
        } else if (permission === Permissions.DEALER_WORK_ANNIVERSARY) {
          MainNav[6].content[2] =
            roleName === Roles.TM_NAME
              ? {
                label: 'Dealer Work Anniversary',
                to: `#/dealer/work-anniversary/${userId}`,
              }
              : {
                label: 'Dealer Work Anniversary',
                to: `#/dealer/work-anniversary-summary`,
              };
        }

        // Dealer List
        if (permission === Permissions.DEALER_LIST) {
          let value =
            (roleName === Roles.TM_NAME || roleName === Roles.CNF_ROLE)
              ? {
                icon: 'dealerListMenuIcon menuImg',
                label: 'Dealer List',
                to: `#/list/dealer-list/all/${userId}`,
              }
              : {
                icon: 'dealerListMenuIcon menuImg',
                label: 'Dealer List',
                to: `#/list/dealer-user-list`,
              };

          MainNav[7] = value;
        }

        // Set Goal
        if (permission === Permissions.SET_GOAL) {
          // if (
          //   roleName === Roles.SH_NAME ||
          //   roleName === Roles.NH_NAME ||
          //   roleName === Roles.BH_NAME
          // ) {
            
          // }
          let value = {
            icon: 'goalMenuIcon menuImg',
            label: 'Set Goal',
            to: '#/goals/set-goal',
          };
          MainNav[8] = value;
        }

        // Admin Functionality
        if (permission === Permissions.ADMIN_FUNCTIONALITY) {
          let value = {
            icon: 'adminMenuIcon menuImg',
            label: 'Admin Functionality',
            content: [],
          };
          MainNav[9] = value;
        }
        if (permission === Permissions.ADMIN_ASSIGN_DEALER_CODE) {
          MainNav[9].content[0] = {
            label: 'Assign Dealer Code',
            to: '#/admin/assign-dealer-code',
          };
        } else if (permission === Permissions.ADMIN_MANAGE_USER) {
          MainNav[9].content[1] = {
            label: 'Manage User',
            to: '#/admin/manage-user',
          };
        } else if (permission === Permissions.ADMIN_MANAGE_DEALER) {
          MainNav[9].content[2] = {
            label: 'Manage Dealer',
            to: '#/admin/manage-dealer',
          };
        } else if (permission === Permissions.LOGIN_REPORT) {
          MainNav[9].content[3] = {
            label: 'Login Report',
            to: '#/admin/login-report',
          };
        }
        else if (permission === Permissions.ADMIN_ASSIGN_TERRITORIES) {
          MainNav[9].content[4] = {
            label: 'Change Territory Manager',
            to: '#/admin/assign-territories',
          };
        }
        else if (permission === Permissions.ADMIN_MANAGE_TERRITORIES) {
          MainNav[9].content[5] = {
            label: 'Manage Territory',
            to: '#/admin/manage-territories',
          };
        }
        else if (permission === Permissions.ADMIN_CHANGE_MANAGER) {
          MainNav[9].content[6] = {
            label: 'Change Manager',
            to: '#/admin/change-manager',
          };
        } else if (permission === Permissions.ADMIN_PRODUCT_LISTS) {
          MainNav[9].content[7] = {
            label: 'Product Lists',
            to: '#/admin/product-list',
          };
        } else if (permission === Permissions.ADMIN_HOLIDAYS) {
          MainNav[9].content[8] = {
            label: 'Holidays',
            to: '#/admin/holidays',
          };
        }

        // Distance Travel
        if (permission === Permissions.DISTANCE_TRAVEL) {
          {
            let isMobile = false;
            let value = {
              icon: 'travelMenuIcon menuImg',
              label: 'Distance Traveled',
              to: `#/travel?isMobile=${isMobile}`,
            };
            MainNav[4] = value;
          }
        }

        // Contact Us
        if (permission === Permissions.CONTACT_US) {
          let value = {
            icon: 'contactMenuIcon menuImg',
            label: 'Contact Us',
            to: '#/settings/contact-us',
          };
          MainNav[11] = value;
        }
      }
    }
    return MainNav;
  };
}

export default MainNavComponent;